import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import { AppStore } from '../Core/AppStore';
import { DisplayListViewModel } from '../DisplayFilters/DisplayListViewModel';
import { UsersStore } from './UsersStore';
import { BsBuilding } from '@react-icons/all-files/bs/BsBuilding';
import { BsFillPeopleFill } from '@react-icons/all-files/bs/BsFillPeopleFill';
import { BsPeople } from '@react-icons/all-files/bs/BsPeople';
export enum UserListViewTypes {
    UserView,
    AccountView,
}

export interface IUserListViewSelectorProps {
    readonly className?: string;
}

@autoinject
@observer
export class UserListViewSelector extends React.Component<IUserListViewSelectorProps> {
    public render() {
        return (
            <UncontrolledButtonDropdown className={this.props.className}>
                <DropdownToggle caret className={this.appStore.isMobile ? 'btn' : 'btn-sm'}>
                    {this.iconClass}
                </DropdownToggle>
                <DropdownMenu end>
                    <DropdownItem className={this.getItemClass(UserListViewTypes.UserView)} onClick={this.setUsersView}>
                        <BsPeople /> User View
                    </DropdownItem>
                    <DropdownItem
                        className={this.getItemClass(UserListViewTypes.AccountView)}
                        onClick={this.setAccountView}
                    >
                        <BsBuilding /> Account View
                    </DropdownItem>
                </DropdownMenu>
            </UncontrolledButtonDropdown>
        );
    }

    @bind
    @action
    private setUsersView() {
        this.usersStore.viewType = UserListViewTypes.UserView;
    }

    @bind
    @action
    private setAccountView() {
        this.usersStore.viewType = UserListViewTypes.AccountView;
    }

    @computed
    private get iconClass() {
        let icon = null;

        switch (this.usersStore.viewType) {
            default:
            case UserListViewTypes.UserView:
                icon = <BsFillPeopleFill className="nav-icon fa" />;
                break;
            case UserListViewTypes.AccountView:
                icon = <BsBuilding className="nav-icon fa" />;
                break;
        }

        return icon;
    }

    private getItemClass(viewType: UserListViewTypes) {
        if (this.usersStore.viewType == viewType) return 'active';
    }
    @inject
    private appStore!: AppStore;
    @inject
    private usersStore!: UsersStore;
}
